<template>
	<div v-if="!$root.isEmpty(promotion)">
		<h3>Promocion ID: {{promotion.id}}</h3>
		<b-table striped hover :items="promotion.settings" :fields="columns" small class="table-condensed" v-if="!$root.isEmpty(promotion)">
			<template v-slot:cell(index)="row">
				{{row.index+1}}
			</template>
			<template v-slot:cell(modifierAmount)="row">
				<span v-if="promotion.rateModifierType=='fixed_rate'">
					${{row.item.modifierAmount}}{{currency}}
				</span>
				<span v-else>
					{{modifierSignText(row.item.modifierSign)}} {{row.item.modifierAmount}} ({{rateModifierTypeText(promotion.rateModifierType)}})
				</span>
			</template>
			<template v-slot:cell(currency)="">
				{{currency}}
			</template>
			<template v-slot:cell(applyReturn)="row">
				<span v-if="row.item.applyReturn">Si</span>
				<span v-else>No</span>
			</template>
		</b-table>
	</div>
</template>

<script>
export default {
	props: {
		type: String
	},
	components: { },
	data() {
		let columns = [
			{ key: "index", label: "#" },
			{ key: "serviceTypeData.name", label: "Service type" },
			{ key: "fromZoneData.name", label: "Zona Pickup" },
			{ key: "toZoneData.name", label: "Zona dropoff" },
			{ key: "ticket", label: "Ticket" },
			{ key: "modifierAmount", label: "Precio" },
			{ key: "currency", label: "Moneda Plan Tarifario" },
			{ key: "applyReturn", label: "¿Aplica Retorno?" }
		];
		return {
			columns:columns,
			promotion:null
		};
	},
	computed: {
		currency(){
			if(this.$root.isEmpty(this.promotion)) return "";
			return this.promotion.ratePlanCurrency
		}
	},
	methods: {
		setData(promoModel){
			this.promotion = promoModel;
		},
		modifierSignText(value){
			if(value==1) return "+"
			if(value==-1) return "-"
			return value;
		},
		rateModifierTypeText(val){
			let text = val;
			switch(val){
				case "percent":
					text ="%";
					break;
				case "amount":
					text= "$"
					break;
			}
			return text
		}
	},
	mounted() {
	},
	watch: {}
};
</script>

